// removed by extract-text-webpack-plugin
module.exports = {"searchHighlight":"_22uZF3pDdw9GTySTaSJ6xu_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-style-loader!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/style-compiler?{"id":"data-v-c5eaed38","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Customers.vue
// module id = 1026
// module chunks = 1